document.addEventListener('DOMContentLoaded', () => {
    initOnFocusEmail();
});

function initOnFocusEmail() {
    document
        .querySelectorAll<HTMLElement>('.js-newsletter-subscription-focus-element')
        .forEach((elem) => {
            const closestCheckbox = elem.closest('form').querySelector('.js-newsletter-subscription-show-on-first-focus');

            if (closestCheckbox) {
                /** The checkbox remains visible after the email input received its first focus! */
                elem.addEventListener('focus', () => {
                    closestCheckbox.classList.remove('hidden');
                })
            }
        });
}
